<div class="modal-header">
    <h5 class="modal-title">Confirmation Required</h5>
    <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="activeModal.dismiss('Cross click')"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="modal-body rosterModal__body">
        <p>
            Are you sure you want to leave: <br />
            <strong>{{ classDetails }}</strong
            >?
        </p>
        <p>
            This class will be removed from your list, and all assignments for this class will no
            longer be available.
        </p>
    </div>
</div>
<div class="modal-footer">
    <input
        type="submit"
        value="Delete"
        class="btn btn-primary"
        (click)="leaveClass(); activeModal.dismiss('Cross click')"
        data-dismiss="modal"
    />
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cross click')">
        OK
    </button>
</div>
